import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

export default function DatePicker({ value, onChange, placeholder = "Pick a date", testid }) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="input-dark flex w-full items-center justify-between text-left"
          data-testid={testid}
          aria-expanded={open}
        >
          <span className={value ? "" : "text-[#8a7b5e]"}>
            {value ? format(value, "EEEE, d MMMM yyyy") : placeholder}
          </span>
          <CalendarIcon size={16} className="shrink-0 text-[#f8b818]" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0" data-testid={`${testid}-popover`}>
        <Calendar
          mode="single"
          selected={value}
          onSelect={(d) => {
            onChange(d);
            setOpen(false);
          }}
          disabled={{ before: new Date() }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
